<template>
  <div class="hm-card landing start">
    <div class="background-container">
      <div class="max-w pills">
      </div>
    </div>
    <div class="max-w">

      <div class="header" v-if="$store.getters['getScore']() > 0 || $store.getters['getData']().hasMedicaid">
        <h1 class="" style="font-weight:bold;">Fantastic!</h1>
        <h2 style="font-weight:normal;">It looks Like You Probably Qualify for Discounts on Prescription Drug Coverage.</h2>
        <div class="calculator">
          <div class="score">
            <stat-circle :radius="65" :progress="$store.getters['getScore']()" :stroke="12"></stat-circle>
          </div>
          <div class="message">
            <p>
              You probably qualify for a subsidy that covers
              <span style="font-weight:bold;">{{$store.getters['getScore']()}}% of your prescription drug coverage premium cost.</span> 
            </p>
          </div>
        </div>
        <p style="text-align: justify; font-size: 1em;">
            We'll make sure our plan recommendations reflect the cost savings you are likely to receive. Remember that in order to get these subsidies for prescription drug coverage, you'll need to apply through the Social Security Administration. We'll show you how to do this later.
        </p>
        <p style="text-align: justify; font-size: 1em;">
            Next we'll get your doctors, prescription drugs, and pharmacy information so we can show you the plans that are your right fit.
        </p>
        <SuiButton color="orange" @click="onClickLink">{{ linkLabel }}</SuiButton>
      </div>

      <div class="header" v-else>
        <h1>You Probably Don’t Qualify for Discounts on Prescription Drug Coverage.</h1>
        <h2>It’s OK – There Are Still Plenty of Plans That May Fit Your Needs</h2>
        <p style="text-align: justify">
          Based on the information you provided, you probably don’t qualify for discounts on your prescription drug coverage. To confirm your eligibility, contact the Social Security Administration. Now that we know, let’s move on and focus on finding the right plan based on your needs.
          Now that you know, let’s focus on finding the right plan based on your needs. We’ll get your doctors, prescription drugs, and pharmacy information so we can show you the right plan based on your needs.
        </p>
        <SuiButton color="orange" @click="onClickLink">{{ linkLabel }}</SuiButton>
      </div>

    </div>
  </div>
</template>

<script>
  import Final from '@/components/small/Final';
  import StatCircle from '@/components/StatCircle';

  export default {
    extends: Final,
    components: {
      StatCircle,
    }
  }
</script>
